//
//
//
//


import forum_optimization_conf from '../../assets/configs/forum/forum.optimization.json'

export default {
  name: "forumobjct",
  data() {
    return {
      forum_optimization_conf: forum_optimization_conf,
    }
  },
  methods: {
    update_forums_options: function (forum_list, add_to_items) {
      var fid_list = Object.keys(forum_list);
      for (var i = 0; i < fid_list.length; ++i) {
        var fid = fid_list[i]
        var fourm_item = {
          'fid': fid,
          'name': forum_list[fid].name,
          'description': forum_list[fid].description
        }
        var tmp_forum_list = forum_list[fid]['list'];
        if (tmp_forum_list) {
          fourm_item['list'] = [];
          this.update_forums_options(tmp_forum_list, fourm_item['list']);
        }
        add_to_items.push(fourm_item);
      }
    },
    get_forum_list: function (fid, forum_list) {
      var forum_conf = this.forum_optimization_conf[fid]
      if (forum_conf) {
        forum_conf['fid'] = fid
        let parent_fid = forum_conf['parent_fid']
        if (parent_fid) {
          var tmp_forum_conf = this.forum_optimization_conf[parent_fid]
          if (tmp_forum_conf) {
            this.get_forum_list(parent_fid, forum_list)
          }
        }
        forum_list.push(forum_conf)
      }
    }
  }
}
